import { PlanTableToolbar } from './PlanTableToolbar'
import { PlanTableData } from './PlanTableData'
import { StyledBox } from './PlanTable.styles'

const PlanTable = () => {
  return (
    <StyledBox>
      <PlanTableToolbar />

      <PlanTableData />
    </StyledBox>
  )
}

export default PlanTable
